<template>
    <div class="bg-white p-4 sm:p-8 font-sans">

        <div class="p-8 sm:p-12 max-w-7xl mx-auto">

            <section class="mb-12 md:mb-16">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
                    <div class="md:col-span-1">
                        <h2 class="text-4xl lg:text-5xl font-extrabold text-orange-500 leading-tight">
                            <span class="bg-orange-500 text-white rounded-lg px-3 py-1">Desafios</span>que<br>precisavam
                            ser<br>superados
                        </h2>
                    </div>
                    <div class="md:col-span-2 text-black space-y-4 text-base lg:text-lg">
                        <p>
                            Com a <strong class="font-bold text-orange-600">OverX</strong>, estabelecimentos de food
                            service conseguiram superar desafios operacionais críticos, como gestão fragmentada de
                            pedidos, falta de integração entre setores e erros operacionais recorrentes.
                        </p>
                        <p>
                            A gestão centralizada proporcionou controle total da operação e ajudou a reduzir o tempo de
                            resposta, melhorando a experiência do cliente.
                        </p>
                    </div>
                </div>
            </section>

            <br />
            <br />

            <section class="mb-12 md:mb-16">
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

                    <div class="bg-orange-500 text-white p-6 rounded-xl flex flex-col justify-between">
                        <p class="text-lg font-medium">
                            De acordo com a experiência com a <strong class="font-bold">OverX</strong>, os resultados
                            são claros:
                        </p>
                        <div class="mt-4 self-start">
                            <div class="bg-gray-900 w-12 h-12 rounded-full flex items-center justify-center">
                                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div class="p-4">
                        <p class="text-5xl lg:text-6xl font-bold bg-orange-500 text-white">70%</p>
                        <p class="mt-3 text-black">
                            afirmam que um CRM é muito importante para fechar negócios.
                        </p>
                    </div>

                    <div class="p-4">
                        <p class="text-5xl lg:text-6xl font-bold bg-orange-500 text-white">41%</p>
                        <p class="mt-3 text-black">
                            dizem esperar investir <span class="text-orange-500 font-semibold">"significativamente
                                mais"</span> em um CRM.
                        </p>
                    </div>

                    <div class="p-4">
                        <p class="text-5xl lg:text-6xl font-bold bg-orange-500 text-white">40%</p>
                        <p class="mt-3 text-black">
                            afirmam que estão investindo <span class="text-orange-500 font-semibold">"significativamente
                                mais"</span> em ferramentas de engajamento de vendas.
                        </p>
                    </div>

                </div>
            </section>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;900&display=swap');

.font-sans {
    font-family: 'Sora', sans-serif;
}

.bg-gray-900 svg {
    transform: rotate(330deg);
}
</style>